<template>
  <div
    :class="[
      'border-b border-n-100 dark:border-n-600 pb-2 last:border-0',
      product.status === 'completed' ? 'opacity-30 ' : ''
    ]"
    @click="handleClick"
  >
    <div class="flex justify-between items-start gap-3">
      <div
        class="flex-1 flex gap-3"
        :class="
          product.deleted || product.status === 'completed'
            ? 'line-through decoration-n-900 dark:decoration-n-0'
            : ''
        "
      >
        <div class="flex-shrink-0 w-8 text-center">
          <span class="font-bold text-lg text-n-900 dark:text-n-0">{{ product.quantity }}</span>
        </div>
        <div class="flex-1">
          <div class="text-base font-medium text-n-900 dark:text-n-0 leading-7">
            {{ product.name }}
            <span v-if="product.comboName" class="text-sm text-n-500 dark:text-n-10">
              ({{ product.comboName }})
            </span>
          </div>
          <div v-if="product.comments" class="text-sm text-n-800 dark:text-n-100 mt-1 italic">
            {{ product.comments }}
          </div>
          <div
            v-if="product.modifiers && product.modifiers.length > 0"
            class="text-base text-n-800 dark:text-n-10 mt-1"
          >
            <div v-for="modifier in product.modifiers" :key="modifier.id" class="mb-1">
              + <template v-if="modifier.quantity > 1">{{ modifier.quantity }}</template>
              {{ modifier.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex-shrink-0 h-7 flex items-center">
        <l-icon v-if="product.status === 'ongoing'" name="time" class="text-y-500" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LIcon } from '@last/core-ui/paprika'

import type { KitchenOrderMapped } from '@/types'

type Props = {
  product: KitchenOrderMapped['mappedProducts'][0]
}

const props = defineProps<Props>()

const emit = defineEmits<{
  statusChange: [status: 'pending' | 'ongoing' | 'completed' | 'cancelled' | null]
}>()

function handleClick() {
  if (props.product.deleted) return

  const status = props.product.status

  if (!status || status === 'pending') {
    emit('statusChange', 'ongoing')
  } else if (status === 'ongoing') {
    emit('statusChange', 'completed')
  } else if (status === 'completed') {
    emit('statusChange', 'pending')
  }
}
</script>
